
import { Alert, Button, Checkbox, Col, DatePicker, Form, Image, Input, Modal, Row, Select, Table, Tag, Upload } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { DeleteOutlined, EditOutlined, MinusOutlined, PlusOutlined, SendOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import Search from 'antd/es/input/Search';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import moment from 'moment';


function ListNotification() {
    const token = useSelector((state) => state.user.token);
    //LIBRARY
    const [data, setData] = useState();
    const [dataCategory, setDataCategory] = useState([]);
    const [dataProduct, setDataProduct] = useState([]);
    const [dataBanner, setDataBanner] = useState([]);
    const [dataStore, setDataStore] = useState([]);
    const [dataLinkSelected, setDataLinkSelected] = useState();
    const [dataLink, setDataLink] = useState([
        {
            value: 'home',
            label: 'Home',
        },
        {
            value: 'store',
            label: 'Toko',
        },
        {
            value: 'banner',
            label: 'Banner',
        },
        {
            value: 'category',
            label: 'Kategori Produk',
        },
        {
            value: 'product',
            label: 'Produk',
        },
        {
            value: 'update',
            label: 'Update',
        },
    ]);
    const [count, setCount] = useState(250);
    const [countData, setCountData] = useState(0);
    const [pageInfo, setPageInfo] = useState('');
    const [loading, setLoading] = useState(false);
    const [isModalSend, setIsModalSend] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setdataModal] = useState(null);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [load, setLoad] = useState(0);
    const [form] = Form.useForm();
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);

    const [imageUrl, setImageUrl] = useState();
    const [file, setFile] = useState();
    const [statusSchedule, setStatusSchedule] = useState(false);
    const [arrInputDate, setArrInputDate] = useState([{ label: '', value: '' }]);
    const [arrInputTime, setArrInputTime] = useState([{ label: '', value: '' }]);
    // //Parameter
    const titlePage = 'Notifikasi';
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            sorter: false,
            key: "no",
            render: (id, record, index) => { ++index; return (page.pagination.current - 1) * 10 + index },
        },
        {
            title: 'Gambar',
            dataIndex: 'NotifImage',
            key: "NotifImage",
            render: (text, record) => {
                return (
                    <>
                        <Image
                            width={80}
                            height={80}
                            src={record.NotifImage}
                            fallback="data:image/png;base64,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"
                        />
                    </>
                );
            },
        },
        {
            title: 'Judul',
            dataIndex: 'NotifHeader',
            key: "NotifHeader",
            sorter: false,
        },
        {
            title: 'Konten',
            dataIndex: 'NotifDetail',
            key: "NotifDetail",
            sorter: false,
        },
        {
            title: 'Tanggal',
            dataIndex: 'Date',
            key: "Date",
            sorter: false,
            render: (text, record) => {
                return (
                    <div>
                        {
                            record.PushNotifDates.map((key, i) => (
                                <Tag key={i}>{key.Date}</Tag>
                            ))
                        }
                    </div>
                )
            }
        },
        {
            title: 'Waktu',
            dataIndex: 'Time',
            key: "Time",
            sorter: false,
            render: (text, record) => {
                return (
                    <div>
                        {
                            record.PushNotifTimes.map((key, i) => (
                                <Tag key={i}>{key.Time}</Tag>
                            ))
                        }
                    </div>
                )
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: 190,
            render: (text, record) => {
                return (
                    <>
                        <Button type="primary" danger style={{ marginRight: 10 }} onClick={() => openModal('send', record)}>
                            <SendOutlined />
                        </Button>
                        <Button type="primary" style={{ marginRight: 10 }} onClick={() => openModal('edit', record)}>
                            <EditOutlined />
                        </Button>
                        <Button type="default" style={{ marginRight: 10 }} onClick={() => openModal('delete', record)}>
                            <DeleteOutlined />
                        </Button>
                    </>
                );
            },
        },
    ];

    useEffect(() => {
        getApi('GET', '/notification?search=' + search + '&page=' + page.pagination.current, 'notification');
        // getApi('GET','/banner?search=' + search + '&page=' + page.pagination.current,'notification');
        if (dataCategory) {
            getApi('GET', '/category', 'category');
        }
        if (countData < count) {
            getApi('GET', '/product?limit=250&page_info=' + pageInfo, 'product');
        }
        if (dataBanner) {
            getApi('GET', '/banner', 'banner');
        }
        if (dataStore) {
            getApi('GET', '/storenopage', 'store');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(page), isAlert, pageInfo,load]);

    const getApi = (method, url, type) => {
        setLoading(true);
        const dataReq = {
            method: method,
            url: url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === 200) {
                switch (type) {
                    case 'notification':
                        var item = res.data.rows;
                        setData(item);
                        setPage({
                            ...page,
                            pagination: {
                                ...page.pagination,
                                total: res.data.count
                            }
                        });
                        break;
                    case 'category':
                        var item = res.data.custom_collections;
                        var row = [];
                        for (let i = 0; i < item.length; i++) {
                            row.push({
                                value: JSON.stringify({ id: item[i].id, title: item[i].TitleCategory }),
                                label: item[i].title,
                            });
                        }
                        setDataCategory(row);
                        break;
                    case 'banner':
                        var item = res.data.rows;
                        var row = [];
                        for (let i = 0; i < item.length; i++) {
                            row.push({
                                value: item[i].BannerId,
                                label: item[i].BannerDetail ? item[i].BannerDetail : 'Belum ada deskripsi',
                            });
                        }
                        setDataBanner(row);
                        break;
                    case 'store':
                        var item = res.data;
                        var row = [];
                        for (let i = 0; i < item.length; i++) {
                            row.push({
                                value: item[i].StoreId,
                                label: item[i].StoreName
                            });
                        }
                        setDataStore(row);
                        break;
                    case 'product':
                        var item2 = res.data.products;
                        var row2 = [];
                        for (let i = 0; i < item2.length; i++) {
                            row2.push({
                                value: item2[i].id,
                                label: item2[i].title,
                            });
                        }
                        let arr = [].concat(dataProduct, row2);
                        setCount(count + 250);
                        setCountData(res.count);
                        setDataProduct(arr);
                        if (res.count >= count) {
                            setPageInfo(res.page_info);
                        } else {
                            setLoading(false);
                        }
                        break;
                }
                setLoading(false);
            } else {
                setLoading(false);
                console.log(res.message);
            }
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        })
    }

    const postApi = (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        const dataReq = {
            method: method,
            url: url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === 200) {
                setLoading(false);
                setIsAlert(true);
                setTextAlert(res.message);
                closeModal();
            } else {
                setLoading(false);
                modalError(res.message);
            }
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        })
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({
            pagination,
            filters,
            ...sorter,
        });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    const searchData = (value) => {
        setSearch(value);
        setLoad(load+1);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    }

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </div>
    );

    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    const uploadFile = (info, type) => {
        setFile(info.file);
        getBase64(info.file, (url) => {
            setImageUrl(url);
        });
    };

    const openModal = (type, data) => {
        setStatusSchedule(false);
        setArrInputDate([{ label: '', value: '' }]);
        setArrInputTime([{ label: '', value: '' }]);
        if (type === 'edit') {
            setdataModal(data);
            var link = 'home';
            if(data.BannerId !== null){
                link = 'banner';
                form.setFieldValue('banner',Number(data.BannerId));
            }else if(data.CategoryId !== null){
                link = 'category';
                form.setFieldValue('category',Number(data.CategoryId));
            }else if(data.ProductId !== null){
                link = 'product';
                form.setFieldValue('product',Number(data.ProductId));
            }else if(data.StoreId !== null){
                link = 'store';
                form.setFieldValue('store',Number(data.StoreId));
            }else if(data.UpdateNotif !== null){
                    link = 'update';
            }
            form.setFieldsValue({
                NotifImage: data.NotifImage,
                NotifDetail: data.NotifDetail,
                NotifHeader: data.NotifHeader,
                links:link
            });
            setDataLinkSelected(link);
            var jsonDate = data.PushNotifDates;
            var jsonTime = data.PushNotifTimes;
            var dates = [];
            var times = [];
            for (let i = 0; i < jsonDate.length; i++) {
                dates.push({
                    label: moment(jsonDate[i].Date),
                    value: jsonDate[i].Date
                })
            }
            for (let i = 0; i < jsonTime.length; i++) {
                times.push({
                    label: moment(jsonDate[0].Date + ' ' + jsonTime[i].Time),
                    value: jsonTime[i].Time
                })
            }
            if (dates.length > 0 && times.length > 0) {
                setArrInputDate(dates);
                setArrInputTime(times);
                setStatusSchedule(true);
            }
            setImageUrl(data.NotifImage);
            setIsModal(true);
        } else if (type === 'send') {
            setdataModal(data);
            setIsModalSend(true);
        } else if (type === 'delete') {
            Modal.confirm({
                title: 'NOTICE',
                content: 'Anda ingin menghapus data ini?',
                onOk: () => postApi('DELETE', '/notification/' + data.PushNotifId, 'del'),
            });
        } else {
            setIsModal(true);
        }
    }

    const closeModal = () => {
        setdataModal(null);
        setIsModal(false);
        form.resetFields();
    }

    const onFinish = (ev) => {
        const form = new FormData();
        var dates = [];
        var times = [];
        for (let i = 0; i < arrInputDate.length; i++) {
            dates.push(arrInputDate[i].value);
        }
        for (let i = 0; i < arrInputTime.length; i++) {
            times.push(arrInputTime[i].value);
        }
        ev.Date = JSON.stringify(dates);
        ev.Time = JSON.stringify(times);
        switch (ev.links) {
            case "update":
                ev.UpdateNotif = true;
                break;
            case "store":
                ev.StoreId = JSON.parse(ev.store);
                break;
            case "banner":
                ev.BannerId = JSON.parse(ev.banner);
                break;
            case "product":
                ev.ProductId = JSON.parse(ev.product);
                break;
            case "category":
                var c = JSON.parse(ev.category);
                ev.CategoryId = c.id;
                ev.TitleCategory = c.title;
                break;

        }
        ev.Status = ev.links;
        // ev.PlayerId = "a418c704-ea66-46cd-a8c5-32e369207dac";
        if (dataModal != null) {
            if (file !== null || file !== undefined) {
                ev.OldNotifImage = dataModal.NotifImage;
                ev.NotifImage = file;
            }
            ev.PushNotifId = dataModal.PushNotifId;
            for (const name in ev) {
                form.append(name, ev[name]);
            }
            postApi('PUT', '/notification', form);
        } else {
            if (file !== null || file !== undefined) {
                ev.NotifImage = file;
            }
            for (const name in ev) {
                form.append(name, ev[name]);
            }
            postApi('POST', '/notification', form);
        }
    }

    const updateArr = (arr, key, value, valueString) => {
        arr[key].value = valueString;
        arr[key].label = value;
    }

    const sendNotif = () => {
        var item = dataModal;
        var data = {
            NotifHeader: item.NotifHeader,
            NotifDetail: item.NotifDetail,
            NotifImage: item.NotifImage
        };
        if (item.BannerId !== null) {
            data.Status = 'banner';
            data.BannerId = item.BannerId
        } else if (item.CategoryId !== null) {
            data.Status = 'category';
            data.CategoryId = item.CategoryId;
            data.TitleCategory = item.TitleCategory;
        } else if (item.ProductId !== null) {
            data.Status = 'product';
            data.ProductId = item.ProductId
        } else if (item.StoreId !== null) {
            data.Status = 'store';
            data.StoreId = item.StoreId
        }
        postApi('POST', '/notificationsend', data);
        setIsModalSend(false);
    }

    return (
        <>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>Daftar Notifikasi</h3>
            <Row>
                <Col span={8}>
                    <Search
                        placeholder="Pencarian"
                        allowClear
                        enterButton="Search"
                        size="medium"
                        onSearch={searchData}
                    />
                </Col>
                <Col span={16} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                    <Button style={{ marginBottom: 10 }} type="primary" onClick={() => { openModal('add', null); }}>
                        <PlusOutlined />
                        <b style={{ marginLeft: 5 }}>Tambah Notifikasi</b>
                    </Button>
                </Col>
            </Row>
            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />
            <Modal title="Form Notifikasi" open={isModal} onOk={form.submit} onCancel={() => closeModal()} okText="Simpan" >
                <Form form={form} name="form" layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="NotifHeader"
                        label="Judul"
                        rules={[
                            {
                                required: true,
                                message: 'Judul kosong!'
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="NotifDetail"
                        label="Konten"
                        rules={[
                            {
                                required: true,
                                message: 'Konten kosong!'
                            },
                        ]}
                    >
                        <Input.TextArea autoSize={true} />
                    </Form.Item>
                    <Form.Item
                        name="NotifImage"
                        label="Gambar"
                        rules={[
                            {
                                required: false,
                                message: 'Gambar kosong!'
                            },
                        ]}
                    >
                        <Upload
                            listType="picture-card"
                            showUploadList={false}
                            onChange={(ev) => uploadFile(ev)}
                            beforeUpload={() => false}
                        >
                            {imageUrl ? (
                                <Image
                                    preview={false}
                                    width={80}
                                    height={80}
                                    src={imageUrl}
                                    fallback="data:image/png;base64,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"
                                />
                            ) : (
                                uploadButton
                            )}
                        </Upload>
                    </Form.Item>

                    <Form.Item
                        name="links"
                        label="Link Notif"
                        rules={[
                            {
                                required: true,
                                message: 'Link Notif kosong!!'
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            placeholder="Pilih Link Notif"
                            optionFilterProp="children"
                            filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input)}
                            filterSort={(optionA, optionB) =>
                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                            }
                            options={dataLink}
                            onChange={(ev) => setDataLinkSelected(ev)}
                        />
                    </Form.Item>
                    {dataLinkSelected === 'banner' && <Form.Item
                        name="banner"
                        label="Pilih Banner"
                        rules={[
                            {
                                required: true,
                                message: 'Banner kosong!!'
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            placeholder="Pilih Banner"
                            optionFilterProp="children"
                            filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input)}
                            filterSort={(optionA, optionB) =>
                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                            }
                            options={dataBanner}
                        />
                    </Form.Item>}


                    {dataLinkSelected === 'store' && <Form.Item
                        name="store"
                        label="Pilih Toko"
                        rules={[
                            {
                                required: true,
                                message: 'Toko kosong!!'
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            placeholder="Pilih Toko"
                            optionFilterProp="children"
                            filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input)}
                            filterSort={(optionA, optionB) =>
                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                            }
                            options={dataStore}
                        />
                    </Form.Item>}

                    {dataLinkSelected === 'category' && <Form.Item
                        name="category"
                        label="Pilih Kategori"
                        rules={[
                            {
                                required: true,
                                message: 'Kategori kosong!!'
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            placeholder="Pilih Kategori"
                            optionFilterProp="children"
                            filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input)}
                            filterSort={(optionA, optionB) =>
                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                            }
                            options={dataCategory}
                        />
                    </Form.Item>}

                    {dataLinkSelected === 'product' && <Form.Item
                        name="product"
                        label="Pilih Produk"
                        rules={[
                            {
                                required: true,
                                message: 'Produk kosong!!'
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            placeholder="Pilih Produk"
                            optionFilterProp="children"
                            filterOption={(input, option) => (option?.label.toLowerCase() ?? '').includes(input)}
                            filterSort={(optionA, optionB) =>
                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                            }
                            options={dataProduct}
                        />
                    </Form.Item>}

                    <Form.Item>
                        <Checkbox checked={statusSchedule} onChange={(ev) => setStatusSchedule(ev.target.checked)}>Jadwalkan Notifikasi</Checkbox>
                    </Form.Item>
                    {
                        statusSchedule === true &&
                        <div>
                            <Row>
                                <Col>
                                    {
                                        arrInputDate.map((key, i) => (
                                            <Form.Item
                                                key={i}
                                                label={"Tanggal " + (i + 1).toString()}
                                                rules={[
                                                    {
                                                        required: statusSchedule,
                                                        message: 'Tanggal kosong!'
                                                    },
                                                ]}
                                            >
                                                <DatePicker picker='date' onChange={(date, dateString) => updateArr(arrInputDate, i, date, dateString)} defaultValue={key.label} />
                                            </Form.Item>
                                        ))
                                    }
                                </Col>
                                <Col>
                                    <Button onClick={() => setArrInputDate([...arrInputDate, { label: '', value: '' }])} style={{ marginLeft: 10, marginTop: 30 }} type="primary"><PlusOutlined /></Button>
                                    <Button onClick={() => setArrInputDate(arrInputDate.splice(0, arrInputDate.length - 1))} style={{ marginLeft: 10, marginTop: 30 }} type="primary"><MinusOutlined /></Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {
                                        arrInputTime.map((key, i) => (
                                            <Form.Item
                                                key={i}
                                                label={"Waktu " + (i + 1).toString()}
                                                rules={[
                                                    {
                                                        required: statusSchedule,
                                                        message: 'Waktu kosong!'
                                                    },
                                                ]}
                                            >
                                                <DatePicker picker='time' onChange={(time, timeString) => updateArr(arrInputTime, i, time, timeString)} defaultValue={key.label} />
                                            </Form.Item>
                                        ))
                                    }
                                </Col>
                                <Col>
                                    <Button onClick={() => setArrInputTime([...arrInputTime, { label: '', value: '' }])} style={{ marginLeft: 10, marginTop: 30 }} type="primary"><PlusOutlined /></Button>
                                    <Button onClick={() => setArrInputTime(arrInputTime.splice(0, arrInputTime.length - 1))} style={{ marginLeft: 10, marginTop: 30 }} type="primary"><MinusOutlined /></Button>
                                </Col>
                            </Row>
                        </div>
                    }
                </Form>
            </Modal>

            <Modal title="Notifikasi" open={isModalSend} onOk={() => sendNotif()} onCancel={() => setIsModalSend(false)} okText="Kirim" >
                <h3>Kirim ulang notifikasi sekarang ?</h3>
            </Modal>
        </>
    );
}

export default ListNotification;